<oly-toolbar [showActions]="isFileLoaded">
  <ng-container slot="top">
    @let isInspectionMode = (isInspectionMode$ | async) ?? false;
    @let isInspectionInProgress = (isInspectionInProgress$ | async) ?? false;
    @let isNotAnalysisMode = (isNotAnalysisMode$ | async) ?? false;
    @let isNotSetupMode = (isNotSetupMode$ | async) ?? false;

    @if (isFileLoaded) {
      <oly-collapsible-container
        animate.enter="open-close-enter"
        animate.leave="open-close-leave"
        title="Quick Actions"
        class="app-toolbar__quick-actions-container"
        (toggled)="onQuickActionsToggled($event)"
      >
        <app-ribbon-quick-actions
          #quickActions
          class="app-toolbar__quick-actions"
        ></app-ribbon-quick-actions>
      </oly-collapsible-container>
    }

    @if (haveInspection && isFileLoaded && featureFlagAnalysis) {
      <div class="app-toolbar__acquisition-actions">
        <evi-button
          iconFont="light"
          [iconName]="isInspectionMode ? 'pause' : 'play'"
          [isIcon]="true"
          [fat]="true"
          [secondary]="true"
          [backgroundColor]="isInspectionMode ? 'orange' : 'green'"
          [backgroundHover]="!isInspectionMode"
          [disabled]="!isFileLoaded || isInspectionInProgress || isNdeFile || hasDeviceDisconnectedOrError || isRemotelyControlled"
          data-testid="play-pause-button"
          (tgclick)="togglePlayPause()"
        ></evi-button>

        <evi-button
          iconFont="light"
          iconName="stop"
          [isIcon]="true"
          [fat]="true"
          [secondary]="true"
          backgroundColor="red"
          [backgroundHover]="true"
          [disabled]="!isFileLoaded || !isInspectionInProgress || isNdeFile || hasDeviceDisconnectedOrError || isRemotelyControlled"
          data-testid="stop-button"
          (tgclick)="stop()"
        ></evi-button>

        <evi-button
          iconFont="light"
          iconName="sliders-h"
          [isIcon]="true"
          [fat]="true"
          [secondary]="true"
          [disabled]="isNotAnalysisMode || isNdeFile || hasDeviceDisconnectedOrError"
          data-testid="setup-button"
          (tgclick)="goToSetup()"
        ></evi-button>

        <evi-button
          iconFont="light"
          iconName="fa-light fa-sparkles"
          [isIcon]="true"
          [fat]="true"
          [secondary]="true"
          [active]="false"
          [disabled]="isSingleBeam || isNotSetupMode || hasDeviceDisconnectedOrError"
          data-testid="calibration-button"
          (tgclick)="openCalibration()"
        ></evi-button>
      </div>
    }
  </ng-container>

  <ng-container slot="bottom">
    @if (isFileLoaded && featureFlagAnalysis) {
      <div>
        <evi-button
          iconFont="light"
          iconName="map-marker-plus"
          [isIcon]="true"
          [fat]="true"
          [secondary]="true"
          data-testid="windview-quick-add-indication-button"
          [disabled]="disableAddIndication"
          (tgclick)="quickAddIndication()"
        ></evi-button>
      </div>
    }

    <evi-button
      iconFont="light"
      iconName="table"
      [isIcon]="true"
      [fat]="true"
      data-testid="windview-table-icon-button"
      [secondary]="true"
      [disabled]="isNotAnalysisMode"
      (tgclick)="toggleIndicationsTable()"
    ></evi-button>
  </ng-container>
</oly-toolbar>
